import React from 'react';
export const ShelvesGreyed = () => (
  <svg width="107px" height="94px" viewBox="0 0 107 94" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1104.000000, -2097.000000)">
        <g transform="translate(1105.000000, 2097.000000)">
          <path
            d="M80.5122,90.8979 C80.5122,92.3009 62.8392,93.4389 41.0372,93.4389 C19.2362,93.4389 1.5622,92.3009 1.5622,90.8979 C1.5622,89.4949 19.2362,88.3569 41.0372,88.3569 C62.8392,88.3569 80.5122,89.4949 80.5122,90.8979"
            fill="#F3F4F6"
          />
          <polygon
            fill="#C3D3D8"
            points="8.527 90.429 12.252 90.429 12.252 0.256 8.527 0.256"
          />
          <polygon
            fill="#C3D3D8"
            points="70.568 90.429 73.637 90.429 73.637 0.256 70.568 0.256"
          />
          <polygon
            fill="#FFFFFF"
            points="0.348 15.664 80.734 15.664 80.734 12.166 0.348 12.166"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.348 15.664 80.734 15.664 80.734 12.166 0.348 12.166"
          />
          <polygon
            fill="#FFFFFF"
            points="0.348 47.625 80.734 47.625 80.734 44.128 0.348 44.128"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.348 47.625 80.734 47.625 80.734 44.128 0.348 44.128"
          />
          <polygon
            fill="#FFFFFF"
            points="0.348 78.576 80.734 78.576 80.734 75.078 0.348 75.078"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.348 78.576 80.734 78.576 80.734 75.078 0.348 75.078"
          />
          <path
            d="M22.8243,68.5639 C22.4343,68.2339 22.2453,67.6819 22.3533,67.1819 C22.4613,66.6829 22.8603,66.2569 23.3523,66.1179 C23.4603,66.0859 23.5823,66.0619 23.6453,65.9679 C23.7813,65.7659 23.5063,65.5429 23.2823,65.4449 C22.5773,65.1379 21.8783,64.7139 21.5013,64.0449 C21.1233,63.3759 21.1813,62.4129 21.8033,61.9599 C22.3163,61.5859 23.0123,61.6579 23.6403,61.5679 C24.1163,61.4999 24.5763,61.3289 24.9813,61.0709 C25.0543,61.0239 25.1283,60.9719 25.1733,60.8979 C25.2463,60.7759 25.2273,60.6199 25.1923,60.4809 C25.1153,60.1689 24.9733,59.8749 24.9353,59.5559 C24.8983,59.2379 24.9983,58.8709 25.2823,58.7219 C25.7553,58.4749 26.3013,58.9809 26.8323,58.9249 C26.8683,58.4579 27.2613,58.0779 27.7003,57.9129 C28.1403,57.7469 28.6233,57.7529 29.0933,57.7619 C29.2933,57.7649 29.5083,57.7739 29.6653,57.8969 C29.8373,58.0309 29.8923,58.2639 29.9153,58.4799 C29.9773,59.0679 29.8763,59.6719 29.6253,60.2069 C29.5403,60.3889 29.4463,60.6279 29.5913,60.7679 C29.6543,60.8289 29.7463,60.8469 29.8343,60.8559 C30.1183,60.8839 30.4063,60.8369 30.6903,60.8689 C30.9733,60.9009 31.2743,61.0399 31.3753,61.3059 C31.4783,61.5759 31.3393,61.8849 31.1293,62.0819 C30.9193,62.2779 30.6483,62.3919 30.3963,62.5329 C29.8333,62.8459 29.3513,63.3039 29.0093,63.8499 C28.8893,64.0429 28.7833,64.2769 28.8603,64.4899 C28.9833,64.8319 29.4403,64.8619 29.8023,64.8899 C30.1843,64.9199 30.5803,65.0259 30.8523,65.2949 C31.1243,65.5649 31.2243,66.0339 30.9923,66.3379 C30.8243,66.5609 30.5343,66.6469 30.2643,66.7189 C29.9403,66.8059 29.6163,66.8939 29.2913,66.9809 C29.8203,67.2719 30.1353,67.9709 30.0273,68.5639"
            fill="#C3D3D8"
          />
          <path
            d="M25.6236,68.4565 C25.6236,68.4565 25.0676,62.8595 28.1656,60.5705"
            stroke="#FFFFFF"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.2623,74.852 L20.9003,74.852 C19.7053,74.852 18.7273,73.873 18.7273,72.679 L18.7273,70.863 C18.7273,69.667 19.7053,68.69 20.9003,68.69 L31.2623,68.69 C32.4573,68.69 33.4353,69.667 33.4353,70.863 L33.4353,72.679 C33.4353,73.873 32.4573,74.852 31.2623,74.852"
            fill="#FFFFFF"
          />
          <path
            d="M31.2623,74.852 L20.9003,74.852 C19.7053,74.852 18.7273,73.873 18.7273,72.679 L18.7273,70.863 C18.7273,69.667 19.7053,68.69 20.9003,68.69 L31.2623,68.69 C32.4573,68.69 33.4353,69.667 33.4353,70.863 L33.4353,72.679 C33.4353,73.873 32.4573,74.852 31.2623,74.852 Z"
            stroke="#C3D3D8"
          />
          <path
            d="M25.6412,66.2192 C26.0992,65.5882 26.7962,65.1342 27.5592,64.9722"
            stroke="#FFFFFF"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="49.949 43.837 64.283 43.837 64.283 26.005 49.949 26.005"
          />
          <polygon
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="49.949 43.837 64.283 43.837 64.283 26.005 49.949 26.005"
          />
          <polygon
            fill="#F3F4F6"
            points="52.941 40.12 61.291 40.12 61.291 29.724 52.941 29.724"
          />
          <g transform="translate(84.000000, 56.710000)">
            <path d="M0.5991,0.5736 L11.1181,0.5736" fill="#FFFFFF" />
            <path
              d="M0.5991,0.5736 L11.1181,0.5736"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(84.000000, 61.710000)">
            <path d="M0.5991,0.6791 L16.7441,0.6791" fill="#FFFFFF" />
            <path
              d="M0.5991,0.6791 L16.7441,0.6791"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(91.000000, 67.710000)">
            <path d="M0.188,0.5531 L14.607,0.5531" fill="#FFFFFF" />
            <path
              d="M0.188,0.5531 L14.607,0.5531"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M90.5112,57.2836 L90.5112,62.3886"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.7983,62.3891 L97.7983,68.2631"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(24.000000, 25.710000)">
            <path d="M0.6251,0.0638 L11.0731,0.0638" fill="#FFFFFF" />
            <path
              d="M0.6251,0.0638 L11.0731,0.0638"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(19.000000, 30.710000)">
            <path d="M0.9317,0.1693 L15.8607,0.1693" fill="#FFFFFF" />
            <path
              d="M0.9317,0.1693 L15.8607,0.1693"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(19.000000, 36.710000)">
            <path d="M0.9317,0.0433 L9.7877,0.0433" fill="#FFFFFF" />
            <path
              d="M0.9317,0.0433 L9.7877,0.0433"
              stroke="#DCE4E7"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M30.7042,25.7738 L30.7042,30.8788"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.6251,30.8793 L24.6251,36.7533"
            stroke="#DCE4E7"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
